(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-hammerjs"), require("inline-style-prefixer"), require("lodash.differenceby"), require("react-motion"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-hammerjs", "inline-style-prefixer", "lodash.differenceby", "react-motion"], factory);
	else if(typeof exports === 'object')
		exports["ReactSwipeableTabs"] = factory(require("react"), require("react-hammerjs"), require("inline-style-prefixer"), require("lodash.differenceby"), require("react-motion"));
	else
		root["ReactSwipeableTabs"] = factory(root["React"], root["Hammerjs"], root["InlineStylePrefixer"], root["LodashDifferenceBy"], root["ReactMotion"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_22__, __WEBPACK_EXTERNAL_MODULE_23__, __WEBPACK_EXTERNAL_MODULE_24__, __WEBPACK_EXTERNAL_MODULE_25__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition